
<template>
  <div>
    <div
      data-v-2ed878fe=""
      class="listingpush"
    />
    
    <!-- Mobile Sidebar (animated in) -->
    <div
      id="modal-filtre"
      class="d-lg-none"
      :class="[
        showFilter
          ? 'show-filter animate__animated animate__backInLeft'
          : 'animate__animated animate__backOutLeft',
        isFirstRender ? 'hide-animation' : '',
      ]"
      style="display: block; background-color: rgba(255, 255, 255, 0.95); position: fixed; z-index: 1050; top: 0; left: 0; height: 100vh; overflow-y: auto;"
    >
      <div class="left_sidebar_area">
        <aside class="left_widgets p_filter_widgets">
          <div class="l_w_title">
            <a
              id="grid-icon2-btn"
              class="grid-icon2"
              @click.prevent="toggleFilter"
            ><i
              class="icon-exit-left2"
              style="font-size: x-large;"
            /> Hide Filters</a>
          </div>

          <!-- Search via Postcode -->
          <div class="widgets_inner cat_widgets">
            <div class="border border-1 rounded p-1">
              <form
                class="ng-pristine ng-valid"
                @submit.prevent="getAddress"
              >
                <input
                  id="bar_search"
                  v-model="postalCode"
                  type="search"
                  class="form-control"
                  name="pql"
                  minlength="3"
                  :placeholder="userpostcode ? `Current: ${userpostcode}` : ''"
                >
                <label
                  class="form-label"
                  for="bar_search"
                  style="margin-left: 0px; padding-top: 0.47rem"
                >Enter Your Postcode</label>
                <button
                  type="submit"
                  name="sendpostcode"
                  class="lnrsubmit"
                  style="line-height: 2; font-size: 20px; padding: 1px 12px"
                >
                  <i class="icon-location" />
                </button>
              </form>
            </div>
          </div>

          <!-- Service Types -->
          <div class="widgets_inner">
            <div class="mb-3 border border-1 rounded p-1">
              <label class="form-id">Service Category:</label>
              <div class="form-check mt-1">
                <input
                  id="category_all"
                  class="form-check-input"
                  type="radio"
                  name="typeFilter"
                  :value="null"
                  :checked="filters.type === null"
                  @change="filters.type = null"
                >
                <label
                  class="form-check-label"
                  for="category_all"
                >
                  All Categories ({{ serviceAds?.length || 0 }})
                </label>
              </div>
              <div
                v-for="type in availableTypes"
                :key="type"
              >
                <div class="form-check mt-1">
                  <input
                    :id="`type_${type}`"
                    class="form-check-input"
                    type="radio"
                    name="typeFilter"
                    :value="type"
                    :checked="filters.type === type"
                    @change="filters.type = type"
                  >
                  <label
                    class="form-check-label"
                    :for="`type_${type}`"
                  >
                    {{ type }} ({{ typeCounts[type] || 0 }})
                  </label>
                </div>
              </div>
            </div>
            
            <!-- Services Filter -->
            <div class="widgets_inner mt-4">
              <label
                class="form-check-label mb-2"
                style="font-weight: bold; display: block;"
              >
                Services
              </label>
              <div
                v-for="service in availableServices"
                :key="'mob_' + service.name"
                class="form-check mt-1"
              >
                <input
                  :id="'mob_service_' + service.id"
                  v-model="filters.services"
                  class="form-check-input"
                  type="checkbox"
                  :value="service.name"
                  :disabled="!filters.services.includes(service.name) && !(dynamicServiceCounts[service.name] > 0)"
                >
                <label
                  class="form-check-label"
                  :for="'mob_service_' + service.id"
                >
                  {{ service.name }} ({{ dynamicServiceCounts[service.name] || 0 }})
                </label>
              </div>
            </div>

            <!-- Mobile Apply Filters Button -->
            <div class="mt-4 mb-4 pb-3 text-center">
              <button
                class="btn btn-primary w-100"
                style="padding: 10px 0; font-size: 1.1em; font-weight: bold; background-color: #0d6efd !important; color: #ffffff !important; border: none; border-radius: 5px;"
                @click.prevent="toggleFilter"
              >
                Apply Filters
              </button>
            </div>
          </div>
        </aside>
      </div>
    </div>
    <!-- /Left Sidebar Filter -->

    <section class="cat_product_area">
      <div class="container conlist">
        <div class="row">
          <!-- Ana İçerik Alanı -->
          <div class="col-lg-12">
            <div
              class="pt-3"
              style="background: linear-gradient(to bottom, #fbf8f8, #ffffff)"
            >
              <div
                class="section-title section-title-dk-blue fl-wrap"
                style="width: 100%; position: relative; text-align: center"
              >
                <h2><span>Services</span></h2>
                <div class="section-subtitle">
                  Services
                </div>
                <span class="section-separator section-separator-dk-blue" />
                <p class="mb-0">
                  Showing {{ totalCount }} ads
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          id="petListingDiv"
          class="row"
        >
          <!-- Desktop Sidebar -->
          <div
            class="col-lg-3 d-none d-lg-block sticky-top"
            style="top: 0px; z-index: 100;"
          >
            <div class="left_sidebar_area">
              <aside class="left_widgets p_filter_widgets">
                <!-- Search via Postcode -->
                <div class="widgets_inner cat_widgets">
                  <div class="border border-1 rounded p-1">
                    <form
                      class="ng-pristine ng-valid"
                      @submit.prevent="getAddress"
                    >
                      <input
                        id="bar_search"
                        v-model="postalCode"
                        type="search"
                        class="form-control"
                        name="pql"
                        minlength="3"
                        :placeholder="userpostcode ? `Current: ${userpostcode}` : ''"
                      >
                      <label
                        class="form-label"
                        for="bar_search"
                        style="margin-left: 0px; padding-top: 0.47rem"
                      >Enter Your Postcode</label>
                      <button
                        type="submit"
                        name="sendpostcode"
                        class="lnrsubmit"
                        style="line-height: 2; font-size: 20px; padding: 1px 12px"
                      >
                        <i class="icon-location" />
                      </button>
                    </form>
                  </div>
                </div>

                <!-- Service Types -->
                <div class="widgets_inner">
                  <div class="mb-3 border border-1 rounded p-1">
                    <label class="form-id">Service Category:</label>
                    <div class="form-check mt-1">
                      <input
                        id="category_all"
                        class="form-check-input"
                        type="radio"
                        name="typeFilter"
                        :value="null"
                        :checked="filters.type === null"
                        @change="filters.type = null"
                      >
                      <label
                        class="form-check-label"
                        for="category_all"
                      >
                        All Categories ({{ serviceAds?.length || 0 }})
                      </label>
                    </div>
                    <div
                      v-for="type in availableTypes"
                      :key="type"
                    >
                      <div class="form-check mt-1">
                        <input
                          :id="`type_${type}`"
                          class="form-check-input"
                          type="radio"
                          name="typeFilter"
                          :value="type"
                          :checked="filters.type === type"
                          @change="filters.type = type"
                        >
                        <label
                          class="form-check-label"
                          :for="`type_${type}`"
                        >
                          {{ type }} ({{ typeCounts[type] || 0 }})
                        </label>
                      </div>
                    </div>
                  </div>
            
                  <!-- Services Filter -->
                  <div class="widgets_inner mt-4">
                    <label
                      class="form-check-label mb-2"
                      style="font-weight: bold; display: block;"
                    >
                      Services
                    </label>
                    <div
                      v-for="service in availableServices"
                      :key="'desk_' + service.name"
                      class="form-check mt-1"
                    >
                      <input
                        :id="'desk_service_' + service.id"
                        v-model="filters.services"
                        class="form-check-input"
                        type="checkbox"
                        :value="service.name"
                        :disabled="!filters.services.includes(service.name) && !(dynamicServiceCounts[service.name] > 0)"
                      >
                      <label
                        class="form-check-label"
                        :for="'desk_service_' + service.id"
                      >
                        {{ service.name }} ({{ dynamicServiceCounts[service.name] || 0 }})
                      </label>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>

          <div class="col-lg-9 col-12">
            <!-- Product Top Bar (Filters & Sorting) -->
            <div class="product_top_bar lst-drps mb-3">
              <div class="d-flex justify-content-between align-items-center w-100 flex-nowrap">
                <div
                  class="left_drop sort-controls"
                  style="flex: 1;"
                >
                  <select
                    v-model="sortOrder"
                    class="selectpicker form-select"
                    style="max-width: 250px; display: block !important;"
                  >
                    <option value="newest">
                      Newest First
                    </option>
                    <option value="oldest">
                      Oldest First
                    </option>
                    <option value="highest_rating">
                      Highest Rating
                    </option>
                    <option value="most_viewed">
                      Most Viewed
                    </option>
                  </select>
                </div>
                <div class="right_page ml-auto msifir d-lg-none">
                  <ul
                    class="search-title-tab-list"
                    style="margin: unset; padding: 0;"
                  >
                    <li>
                      <a
                        href="#"
                        type="button"
                        class="gorunur"
                        style="row-gap: 0px; font-size: 30px; border: none; width: unset; display: flex; flex-direction: column; align-items: center;"
                        @click.prevent="toggleFilter"
                      >
                        <i
                          class="icon-list3"
                          style="font-size: 40px"
                        />
                        <span style="font-size: 10px">Filters</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- /Product Top Bar -->

            <div
              v-if="loading"
              class="loading"
            >
              Loading...
            </div>
            <div
              v-if="error"
              class="error"
            >
              {{ error }}
            </div>
            
            <!-- Active Filters (Pills) -->
            <div
              v-if="hasActiveFilters"
              class="selected-filters mb-4"
            >
              <div class="filter-pills">
                <!-- Category Filter -->
                <div
                  v-if="filters.type"
                  class="filter-pill"
                >
                  <span>Category: {{ filters.type }}</span>
                  <button
                    class="remove-filter"
                    @click="filters.type = ''"
                  >
                    <i class="icon-cross" />
                  </button>
                </div>

                <!-- Location Filter -->
                <div
                  v-if="filters.postalTown"
                  class="filter-pill"
                >
                  <span>Location: {{ filters.postalTown }}</span>
                  <button
                    class="remove-filter"
                    @click="filters.postalTown = ''"
                  >
                    <i class="icon-cross" />
                  </button>
                </div>

                <!-- Services Filter (Loop through selected services) -->
                <div
                  v-for="service in filters.services"
                  :key="service"
                  class="filter-pill"
                >
                  <span>{{ service }}</span>
                  <button
                    class="remove-filter"
                    @click="removeServiceFilter(service)"
                  >
                    <i class="icon-cross" />
                  </button>
                </div>

                <!-- Clear All Filters -->
                <button
                  class="reset-all-filters"
                  @click="resetAllFilters"
                >
                  Clear All Filters
                </button>
              </div>
            </div>

            <div
              v-if="filteredAndSortedAds.length"
              class="latest_product_inner pt-0"
            >
              <div
                id="bilgin"
                class="most_product_inner"
              >
                <!-- CARD DONGUSU BASLANGICI -->
                <div
                  v-for="service in filteredAndSortedAds"
                  :key="service.id"
                  class="listing-item listing-item-loop"
                >
                  <article class="geodir-category-listing fl-wrap">
                    <div class="azp_element preview_listing geodir-category-img">
                      <div class="geodir-js-favorite_btn">
                        <a
                          href="#"
                          class="save-btn logreg-modal-open"
                          data-message="Logging in first to save this listing."
                        ><i class="fas fa-heart" /><span>Save</span></a>
                      </div>
                      <div
                        v-if="service.rating >= 4.5"
                        class="listing-featured"
                      >
                        Top Rated
                      </div>
                      <RouterLink
                        :to="{ name: 'service-details', params: { id: service.id } }"
                        class="listing-thumb-link geodir-category-img-wrap fl-wrap"
                      >
                        <img
                          width="378"
                          height="252"
                          class="respimg"
                          alt=""
                          :src="service.coverImage"
                        >

                        <div class="overlay" />
                      </RouterLink>
                      <div class="listing-avatar">
                        <a href=""><img :src="service.photoURL"></a>
                        <span class="avatar-tooltip lpre-avatar">{{
                          formatDate(service.createdAt)
                        }}</span>
                      </div>
                      <div
                        v-if="service.type"
                        class="lcard-saleoff"
                      >
                        <div class="saleoff-inner">
                          {{ service.type }}
                        </div>
                      </div>
                      <div class="geodir-category-opt clearfix">
                        <div class="listing-rating-count-wrap flex-items-center">
                          <div class="review-score">
                            {{ service.rating || '0.0' }}
                          </div>
                          <div class="review-details">
                            <div
                              class="listing-rating card-popup-rainingvis"
                              :data-rating="service.rating || '0.0'"
                            >
                              <span class="stars-wrapper"><i class="fas fa-star" /></span>
                            </div>
                            <div class="reviews-count">
                              {{ service.reviewsCount || 0 }} comments
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="lcfields-wrap dis-flex" />
                    </div>
                    <div class="azp_element preview_listing_content geodir-category-content">
                      <div class="geodir-category-content-title fl-wrap">
                        <div class="geodir-category-content-title-item">
                          <h3 class="title-sin_map">
                            <RouterLink :to="{ name: 'service-details', params: { id: service.id } }">
                              {{
                                service.companyName || service.title || 'Service Provider'
                              }}
                            </RouterLink>
                          </h3>
                          <div
                            v-if="service.postalTown || service.address"
                            class="geodir-category-location fl-wrap"
                          >
                            <a
                              href=""
                              class="map-item"
                              target="_blank"
                            ><i class="fas fa-map-marker-alt" />{{ service.postalTown || service.address }}</a>
                          </div>
                        </div>
                      </div>
                      <div class="geodir-category-text fl-wrap">
                        <h5>{{ service.type || 'Personal' }}</h5>
                        <div class="lcfields-wrap dis-flex" />
                        <div
                          class="facilities-list fl-wrap dis-flex flw-wrap"
                          style="flex-wrap: wrap"
                        >
                          <div class="facilities-list-title">
                            Services:
                          </div>
                          <ul
                            v-if="service.services && service.services.length"
                            class="no-list-style mrg-0 dis-inflex"
                          >
                            <li
                              v-for="(serviceItem, index) in service.services.slice(0, 3)"
                              :key="index"
                              class="tolt"
                              :data-microtip-position="'top'"
                              :data-tooltip="serviceItem"
                            >
                              <i class="fas fa-award" />{{ serviceItem }}
                            </li>

                            <li
                              v-if="service.services.length > 3"
                              class="tolt"
                              :data-microtip-position="'top'"
                              :data-tooltip="service.services.slice(3).join(', ')"
                            >
                              <i class="fas fa-plus-circle" /> +{{ service.services.length - 3 }} more
                            </li>
                          </ul>
                        </div>
                        <div class="lcard-price">
                          Views: {{ service.viewCount || 0 }}
                        </div>
                      </div>
                      <div class="geodir-category-footer fl-wrap dis-flex">
                        <div class="geodir-opt-list dis-flex">
                          <ul class="no-list-style">
                            <li class="lcard-bot-infos">
                              <a
                                href="javascript:void(0)"
                                class="show_gcc"
                              ><i class="fas fa-envelope" /><span class="geodir-opt-tooltip">Contact Info</span></a>
                            </li>
                            <li class="lcard-bot-gallery">
                              <div class="dynamic-gal gdop-list-link">
                                <i class="fas fa-search-plus" /><span class="geodir-opt-tooltip">Gallery</span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
                <!-- CARD DONGUSU SONU -->
              </div>
            </div>
            <div
              v-else-if="loading"
              class="no-data"
            >
              <LoadingSpinner />
            </div>
            <div
              v-else
              class="no-listings"
            >
              <div class="empty-state">
                <i class="fas fa-search" />
                <h3>No listings found</h3>
                <p>There are currently no service listings available matching your filters.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import { useServiceStore } from '@/stores/serviceStore';
import { useUserStore } from '@/stores/userStore';
import { storeToRefs } from 'pinia';
import { db } from '@/firebase/index.js';
import { doc, getDoc } from 'firebase/firestore';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { validatePostalCode } from '@/utils/locationUtils';

const userStore = useUserStore();
const { userData } = storeToRefs(userStore);
const serviceStore = useServiceStore();
const { serviceAds, loading, error } = storeToRefs(serviceStore);

// Filter States
const sortOrder = ref('newest');
const filters = ref({
  postalTown: '',
  type: '',
  services: []
});
const availableServices = ref([]);


const fetchAvailableServices = async () => {
  try {
    const docSnap = await getDoc(doc(db, 'account_types', 'service_accounts'));
    if (docSnap.exists()) {
      const typesArray = docSnap.data().types || [];
      availableServices.value = typesArray.map((type, index) => ({
        id: index.toString(),
        name: type
      }));
    }
  } catch (error) {
    console.error('Error fetching services:', error);
  }
};

onMounted(() => {
  serviceStore.fetchServiceAds();
  fetchAvailableServices();
  const localPostcode = localStorage.getItem('userPostcode');
  if (localPostcode) {
    filters.value.postalTown = localPostcode;
  } else if (userData.value?.city) {
    filters.value.postalTown = userData.value.city;
  }
});

// Sidebar State
const showFilter = ref(false);
const isFirstRender = ref(true);

const toggleFilter = () => {
  if (isFirstRender.value) {
    isFirstRender.value = false;
  }
  showFilter.value = !showFilter.value;
};


const postalCode = ref('');
const postCodeUpdateTrigger = ref(0);

const userpostcode = computed(() => {
  postCodeUpdateTrigger.value;
  const localPostcode = localStorage.getItem('userPostcode');
  if (localPostcode) {
    return localPostcode;
  }
  if (userData.value?.postalCode) {
    return userData.value.postalCode;
  }
  return 'Postcode not available';
});

const getAddress = async () => {
  if (!postalCode.value.trim()) return;

  try {
    const result = await validatePostalCode(postalCode.value.toLowerCase().replace(/\s/g, ''));

    if (!result.isValid) {
      throw new Error(result.error || 'Post code is invalid');
    }

    localStorage.setItem('userLat', result.latitude);
    localStorage.setItem('userLng', result.longitude);
    localStorage.setItem('userPostcode', result.postalTown);

    postCodeUpdateTrigger.value++;
    
    // Filtreyi güncelle (Town ismine göre arama yapması için)
    filters.value.postalTown = result.postalTown;
  } catch (err) {
    console.error('Error getting address:', err);
    // You could show a modal or toast here
  }
};


// Compute unique types dynamically
const availableTypes = computed(() => {
  const types = new Set();
  if (serviceAds.value) {
    serviceAds.value.forEach(ad => {
      if (ad.type) types.add(ad.type);
    });
  }
  return Array.from(types);
});

// Compute counts for each type
const typeCounts = computed(() => {
  const counts = {};
  if (serviceAds.value) {
    serviceAds.value.forEach(ad => {
      if (ad.type) {
        counts[ad.type] = (counts[ad.type] || 0) + 1;
      }
    });
  }
  return counts;
});

// Format Date
const formatDate = (dateValue) => {
  try {
    const date = dateValue?.toDate ? dateValue.toDate() : new Date(dateValue);
    if (isNaN(date)) throw new Error('Invalid date');

    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Istanbul',
    });
  } catch (error) {
    return 'Tarih bilgisi yok';
  }
};

const parseDate = (dateValue) => {
  try {
    const date = dateValue?.toDate ? dateValue.toDate() : new Date(dateValue);
    return date.getTime();
  } catch {
    return 0;
  }
};

const filteredAndSortedAds = computed(() => {
  if (!serviceAds.value) return [];
  
  let result = [...serviceAds.value];
  
  // Apply Category/Type Filter
  if (filters.value.type) {
    result = result.filter(ad => ad.type === filters.value.type);
  }
  
  // Apply Location/Town Filter
  if (filters.value.postalTown) {
    const searchTown = filters.value.postalTown.toLowerCase();
    result = result.filter(ad => ad.postalTown && ad.postalTown.toLowerCase().includes(searchTown));
  }
  
  // Apply Services Filter (AND logic)
  if (filters.value.services && filters.value.services.length > 0) {
    result = result.filter(ad => {
      if (!ad.services || !Array.isArray(ad.services)) return false;
      return filters.value.services.every(s => ad.services.includes(s));
    });
  }
  
  // Sort
  result.sort((a, b) => {
    if (sortOrder.value === 'newest') {
      return parseDate(b.createdAt) - parseDate(a.createdAt);
    } else if (sortOrder.value === 'oldest') {
      return parseDate(a.createdAt) - parseDate(b.createdAt);
    } else if (sortOrder.value === 'highest_rating') {
      return (b.rating || 0) - (a.rating || 0);
    } else if (sortOrder.value === 'most_viewed') {
      return (b.viewCount || 0) - (a.viewCount || 0);
    }
    return 0;
  });
  
  return result;
});

const dynamicServiceCounts = computed(() => {
  const counts = {};
  filteredAndSortedAds.value.forEach(ad => {
    if (ad.services && Array.isArray(ad.services)) {
      ad.services.forEach(service => {
        counts[service] = (counts[service] || 0) + 1;
      });
    }
  });
  return counts;
});

const totalCount = computed(() => filteredAndSortedAds.value.length);

const hasActiveFilters = computed(() => {
  return filters.value.type !== '' || 
         filters.value.postalTown !== '' || 
         filters.value.services.length > 0;
});

const resetAllFilters = () => {
  filters.value.type = '';
  filters.value.postalTown = '';
  filters.value.services = [];
};

const removeServiceFilter = (serviceToRemove) => {
  filters.value.services = filters.value.services.filter(s => s !== serviceToRemove);
};
</script>
<style scoped>
  .selected-filters {
    padding: 10px 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
  }

  .filter-label {
    font-weight: 500;
    color: #666;
  }

  .filter-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }

  .filter-pill {
    display: inline-flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 0.9rem;
    color: #333;
  }

  .remove-filter {
    background: none;
    border: none;
    color: #c5322d;
    margin-left: 5px;
    cursor: pointer;
    padding: 0 5px;
    font-size: 0.8rem;
  }

  .remove-filter:hover {
    color: #a52925;
  }

  .reset-all-filters {
    background-color: #c5322d;
    color: white;
    border: none;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .reset-all-filters:hover {
    background-color: #a52925;
  }

  img {
    border: 0;
    -ms-interpolation-mode: bicubic;
    vertical-align: middle;
  }

  .clearfix:before,
  .clearfix:after,
  .container:before,
  .container:after,
  .container-fluid:before,
  .container-fluid:after,
  .row:before,
  .row:after {
    content: ' ';
    display: table;
  }

  .mrg-0 {
    margin: 0;
  }

  .no-list-style {
    list-style: none;
    margin: 0;
  }

  .dis-inflex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0;
    justify-content: flex-start;
  }
  input[type='text'],
  input[type='email'],
  input[type='password'],
  input[type='button'],
  input[type='number'],
  input[type='tel'],
  textarea,
  select {
    border: 1px solid #e5e7f2;
    background: #f9f9f9;
    width: 100%;
    padding: 10px 20px;
    border-radius: 4px;
    color: #7d93b2;
    font-size: 0.923em;
    line-height: 18px;
    outline: none;
    overflow: hidden;
    z-index: 1;
  }
  option {
    font-weight: normal;
    display: block;
    padding-block-start: 0px;
    padding-block-end: 1px;
    min-block-size: 1.2em;
    padding-inline: 2px;
    white-space: nowrap;
  }
  select {
    text-rendering: auto;
    color: fieldtext;
    letter-spacing: normal;
    word-spacing: normal;
    line-height: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    text-align: start;
    -webkit-rtl-ordering: logical;
    cursor: default;
    white-space: pre;
  }

  /* cardlar*/
  #bilgin {
    -webkit-transition: all 100ms linear;
    -o-transition: all 100ms linear;
    transition: all 100ms linear;

    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    max-width: 100%;
    margin: 0 -8px;
    margin: 0;
    overflow: hidden;
  }

  .listing-item {
    overflow: hidden;
  }

  .listing-item {
    padding: 0 8px;
    margin-bottom: 12px;
  }

  .listing-item .geodir-category-listing {
    margin-bottom: 12px;
  }

  .geodir-category-listing {
    border-radius: 10px;
    background: #fff;
    border: 1px solid #eee;
  }

  .fl-wrap {
    position: relative;
  }

  article {
    display: block;
  }

  .listing-item .geodir-category-img {
    position: relative;
  }

  .geodir-category-img {
    width: 100%;
    position: relative;
    border-radius: 10px 10px 0 0;
  }

  .geodir-category-img:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 20px;
    border-radius: 15px 15px 0 0;
    background: #fff;
    z-index: 3;
  }

  .geodir-js-favorite_btn {
    position: absolute;
    left: 20px;
    top: 20px;
    cursor: pointer;
    color: #fff;
    text-align: center;
  }

  .geodir-js-favorite_btn .save-btn {
    display: inline-block;
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .geodir-js-favorite_btn i {
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 100%;
    background: #425998;
    position: relative;
    z-index: 2;
  }

  .geodir-js-favorite_btn span {
    border-radius: 36px;
    background: #425998;
    left: -36px;
    height: 36px;
    line-height: 36px;
    color: #fff;
    padding: 0 18px 0 48px;
    font-size: 0.845em;
    font-weight: 600;
    position: relative;
    top: 0;
    z-index: 1;
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    opacity: 0;
    margin-top: -2px;
    visibility: hidden;
  }

  .geodir-js-favorite_btn:hover span {
    opacity: 1;
    visibility: visible;
    margin-top: 0;
  }

  .geodir-js-favorite_btn:hover i {
    color: #70243b;
  }

  .geodir-category-listing:hover .geodir-category-img-wrap img,
  .gallery-item:hover img,
  .listing-item-grid:hover .bg {
    -webkit-transform: scale(1.12);
    -ms-transform: scale(1.12);
    transform: scale(1.12);
  }

  .geodir-category-img-wrap {
    z-index: 0;
  }

  .geodir-category-img-wrap {
    overflow: hidden;
    border-radius: 10px 10px 0 0;
    display: inline-block;
    width: 100%;
    aspect-ratio: 1 / 1;
    display: flex;
  justify-content: center; /* yatayda ortala */
  align-items: center;     /* dikeyde ortala */
  background-color: #f7f7f7;
  }

  .lcard-saleoff {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .saleoff-inner {
    position: relative;
    background: #5ecfb1;
    padding: 8px 18px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    font-size: 11px;
    color: #fff;
    min-height: 22px;
  }

  .saleoff-inner:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 0;
    border-top: 20px solid #5ecfb1;
    border-left: 20px solid transparent;
    margin-left: -16px;
    top: 0;
    bottom: auto;
  }

  .saleoff-inner:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 0;
    border-bottom: 20px solid #5ecfb1;
    border-left: 20px solid transparent;
    margin-left: -16px;
    top: auto;
    bottom: 0;
  }

  .lcard-saleoff + .geodir_status_date {
    top: 70px;
  }

  .geodir-js-favorite_btn + .listing-featured {
    top: 70px;
  }

  .listing-featured {
    position: absolute;
    z-index: 4;
    left: 20px;
    top: 20px;
    color: #fff;
    cursor: pointer;
    font-size: 0.845em;
    padding: 6px 10px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #f75c96;
  }

  .listing-featured:before {
    top: 0;
    bottom: auto;
    border-right: 20px solid transparent;
    border-top: 20px solid #f75c96;
  }

  .listing-featured:before,
  .listing-featured:after {
    content: ' ';
    display: block;
    position: absolute;
    right: -16px;
  }

  .listing-featured:after {
    top: auto;
    bottom: 0;
    border-right: 20px solid transparent;
    border-bottom: 20px solid #f75c96;
  }

  .listing-featured:before,
  .listing-featured:after {
    content: ' ';
    display: block;
    position: absolute;
    right: -16px;
  }

  .geodir-category-img-wrap:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    background-color: #f7f7f730;
    z-index: 2;
  }

  .geodir-category-img-wrap img {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
    -o-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
    transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
    width: 100%;
    height: auto;
    max-width: 100%;
  max-height: 100%;
  object-fit: contain;

  }

  .respimg {
    max-width: 100%;
    height: auto;
  }

  .listing-avatar {
    position: absolute;
    bottom: -5px;
    right: 40px;
    z-index: 14;
  }

  .listing-avatar img {
    width: 50px !important;
    height: 50px !important;
    -webkit-box-shadow: 0px 0px 0px 6px white;
    box-shadow: 0px 0px 0px 6px white;
    border-radius: 100%;
    position: relative;
    z-index: 2;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .avatar-tooltip.lpre-avatar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-left: 15px;
    text-align: left;
    white-space: nowrap;
  }

  .avatar-tooltip {
    position: absolute;
    top: 0;
    margin-top: 4px;
    opacity: 0;
    right: 0;
    padding-right: 60px;
    min-width: 200px;
    visibility: hidden;
    height: 56px;
    line-height: 56px;
    border-radius: 56px;
    z-index: 1;
    background: #fff;
    color: #878c9f;
    font-size: 0.845em;
    font-weight: 600;
    -webkit-box-shadow: 0 9px 26px rgba(58, 87, 135, 0.15);
    box-shadow: 0 9px 26px rgba(58, 87, 135, 0.15);
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }

  .listing-avatar:hover .avatar-tooltip {
    margin-top: -2px;
    opacity: 1;
    visibility: visible;
  }

  .avatar-tooltip.lpre-avatar strong {
    max-width: 100px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 5px;
  }

  .strong {
    border: none;
    outline: 0;
    vertical-align: baseline;
    text-decoration: none;
    margin: 0;
    padding: 0;
  }

  .geodir_status_date {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 6px 10px;
    color: #fff;
    font-size: 0.845em;
    border-radius: 20px;
    -webkit-box-shadow: 0px 0px 0px 5px rgba(255, 255, 255, 0.2);
    box-shadow: 0px 0px 0px 5px rgba(255, 255, 255, 0.2);
  }

  .lstatus-closed {
    background: #f75c96;
  }

  .geodir_status_date i {
    margin-right: 10px;
  }

  .geodir-category-opt {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    z-index: 3;
    padding: 10px 20px;
    cursor: inherit;
  }

  .flex-items-center {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .listing-rating-count-wrap .review-score {
    background: #384f95;
    color: #fff;
    font-weight: 600;
    border-radius: 4px;
    padding: 10px;
    font-size: 1em;
    margin-right: 12px;
  }

  .listing-rating i {
    font-size: 10px;
    margin-right: 4px;
    position: relative;
    z-index: 2;
  }

  .listing-rating i {
    color: #facc39;
  }

  .listing-rating-count-wrap .reviews-count {
    color: #fff;
    font-size: 0.845em;
    position: relative;
    top: 2px;
  }

  .dis-flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .listing-item .geodir-category-content,
  .listing-item .geodir-category-img {
    position: relative;
  }

  .geodir-category-content-title {
    padding: 2px 20px 20px;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  .geodir-category-content-title-item {
    width: 100%;
    position: relative;
    z-index: 1;
  }

  .geodir-category-content h3,
  .cart-details_text .geodir-category-content-title-item h3 {
    text-align: left;
    font-weight: 600;
    font-size: 1.23em;
    margin-bottom: 10px;
    font-family: 'Nunito', sans-serif;
  }

  h3 {
    font-size: 22px;
    font-size: 1.375rem;
    line-height: 1.13636364;
  }

  .geodir-category-content h3 a {
    color: #566985;
  }

  .geodir-category-location a {
    color: #7d93b2;
    text-align: left;
    font-size: 0.923em;
  }

  .geodir-category-location a i {
    padding-right: 6px;
    color: #70243b;
  }

  .geodir-category-text {
    padding: 0 20px;
  }

  .facilities-list {
    margin: 10px 0;
    width: 100%;
  }

  .facilities-list-title {
    margin-right: 10px;
    color: #566985;
    font-weight: 700;
    width: 100%;
  }
  .facilities-list ul{
    min-height: 50px;
  }
  .facilities-list li {
    cursor: pointer;
    position: relative;
    width: 49%;
  }

  .tolt[data-microtip-position|='top']::before {
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
    bottom: 100%;
    left: 50%;
  }

  .tolt:before {
    background-size: 100% auto !important;
    content: '';
  }

  .tolt:before,
  .tolt:after {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    opacity: 0;
    pointer-events: none;
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    position: absolute;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 10;
    -webkit-transform-origin: top;
    -ms-transform-origin: top;
    transform-origin: top;
  }

  .tolt[data-microtip-position|='top']:hover::before {
    -webkit-transform: translate3d(-50%, -5px, 0);
    transform: translate3d(-50%, -5px, 0);
  }

  .tolt[data-microtip-position='top']:hover::after {
    -webkit-transform: translate3d(-50%, -5px, 0);
    transform: translate3d(-50%, -5px, 0);
  }

  .tolt[data-microtip-position|='top']::after {
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
    bottom: 100%;
    left: 50%;
  }

  .tolt[data-microtip-position|='top']::after {
    margin-bottom: 11px;
  }

  .tolt:hover::before,
  .tolt:hover::after {
    opacity: 1;
    pointer-events: auto;
  }

  .tolt::after {
    border-radius: 2px;
    background: #313e6e;
    color: #fff;
    content: attr(data-tooltip);
    font-size: 0.845em;
    font-weight: 400;
    padding: 0 20px;
    height: 30px;
    line-height: 30px;
    white-space: nowrap;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
  }

  .tolt:before,
  .tolt:after {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    opacity: 0;
    pointer-events: none;
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    position: absolute;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 10;
    -webkit-transform-origin: top;
    -ms-transform-origin: top;
    transform-origin: top;
  }

  .facilities-list li i {
    font-size: 1.23em;
    color: #70243b;
    margin-right: 5px;
  }

  .lcard-distance,
  .lcard-price {
    padding-bottom: 10px;
  }

  .geodir-category-footer {
    margin: 4px 0 0 0;
    padding: 0 20px;
    border-top: 1px solid #eee;
  }

  .listing-cats-wrap {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .listing-cats-wrap,
  .geodir-category_price,
  .geodir-opt-list {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .flex-items-center {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .listing-item-category-wrap {
    position: relative;
  }

  .listing-item-category {
    width: 36px;
    height: 36px;
    line-height: 36px;
    color: #fff;
    border-radius: 100%;
    position: relative;
    text-align: center;
    background-color: #70243b;
  }

  .listing-item-category-wrap span {
    margin-left: 10px;
    position: relative;
    color: #7d93b2;
  }

  .geodir-opt-list {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .geodir-opt-list {
    position: relative;
    margin-left: auto;
  }

  .geodir-opt-list:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #eee;
  }

  .geodir-opt-list ul {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }

  .no-list-style {
    list-style: none;
    margin: 0;
  }

  .geodir-opt-list li {
    margin-bottom: 0;
  }

  .geodir-opt-list li {
    margin-left: 16px;
  }

  .geodir-opt-list a,
  .gdop-list-link {
    position: relative;
    font-size: 1.23em;
    color: #9ea6ba;
    cursor: pointer;
  }

  .geodir-opt-tooltip,
  .price-name-tooltip {
    position: absolute;
    opacity: 0;
    right: 0;
    top: -40px;
    height: 30px;
    line-height: 30px;
    min-width: 100px;
    margin-left: -65px;
    color: #fff;
    font-size: 12px;
    visibility: hidden;
    border-radius: 2px;
    background: #313e6e;
    z-index: 3;
  }

  .geodir-opt-list a:hover i,
  .gdop-list-link:hover i,
  .header-sec-link a:hover i,
  .hero-categories li a:hover i {
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    -webkit-animation: bounce 1s;
    animation: bounce 1s;
  }

  .geodir-opt-list li:hover .geodir-opt-tooltip,
  .geodir-category_price:hover .price-name-tooltip {
    opacity: 1;
    visibility: visible;
    text-align: center;
  }

  .geodir-opt-tooltip,
  .price-name-tooltip {
    position: absolute;
    opacity: 0;
    right: 0;
    top: -40px;
    height: 30px;
    line-height: 30px;
    min-width: 100px;
    margin-left: -65px;
    color: #fff;
    font-size: 12px;
    visibility: hidden;
    border-radius: 2px;
    background: #313e6e;
    z-index: 3;
  }

  .geodir-category_contacts.visgdcc {
    opacity: 1;
    visibility: visible;
  }

  .geodir-category_contacts {
    position: absolute;
    right: 20px;
    bottom: 70px;
    padding: 20px 20px;
    background: #fff;
    -webkit-box-shadow: 0 9px 26px rgba(58, 87, 135, 0.15) !important;
    box-shadow: 0 9px 26px rgba(58, 87, 135, 0.15) !important;
    z-index: 20;
    max-width: 270px;
    border-radius: 4px;
    border: 1px solid #eee;
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    opacity: 0;
    visibility: hidden;
  }

  .close_gcc {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 3;
    font-size: 1.077em;
    color: #9ea6ba;
    cursor: pointer;
  }

  .geodir-category_contacts ul {
    position: relative;
    z-index: 2;
  }

  .geodir-category_contacts li {
    width: 100%;
    margin: 5px 0;
    text-align: left;
  }

  .geodir-category_contacts li span {
    margin-right: 10px;
    color: #9ea6ba;
  }

  .geodir-category_contacts li span,
  .geodir-category_contacts li a {
    color: #7d93b2;
    text-align: left;
    font-size: 0.923em;
    font-weight: 600;
  }

  .geodir-category_contacts li span i {
    margin-right: 6px;
  }

  .geodir-category_contacts li span,
  .geodir-category_contacts li a {
    color: #7d93b2;
    text-align: left;
    font-size: 0.923em;
    font-weight: 600;
  }

  .geodir-category-listing:after {
    content: '';
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 0;
    z-index: -1;
    height: 50px;
    border-radius: 50%;
    -webkit-box-shadow: 0 10px 14px 0 rgba(37, 44, 65, 0.12);
    box-shadow: 0 10px 14px 0 rgba(37, 44, 65, 0.12);
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  @media (min-width: 56.25rem) {
    h3 {
      font-size: 28px;
      font-size: 1.75rem;
      line-height: 1.25;
    }
  }

  @media (min-width: 43.75rem) {
    h3 {
      font-size: 24px;
      font-size: 1.5rem;
      line-height: 1.25;
    }
  }

  @media (min-width: 430px) {
    .listing-item {
      width: 100%;
    }
  }

  @media (min-width: 768px) {
    .listing-item {
      width: 50%;
    }
  }

  @media (min-width: 992px) {
    .listings-grid-wrap.two-cols .listing-item {
      width: 50%;
    }

    .listing-item {
      width: 33.333333333333336%;
    }
  }

  @media (min-width: 992px) {
  }

  @media only screen and (max-width: 768px) {
    .listing-item {
      top: 0;
      width: 100%;
    }
  }
  .no-listings {
    width: 100%;
    padding: 40px 0;
    text-align: center;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    background-color: #f9f9f9;
    border-radius: 10px;
    margin: 20px 0;
  }

  .empty-state i {
    font-size: 48px;
    color: #70243b;
    margin-bottom: 15px;
  }

  .empty-state h3 {
    color: #566985;
    margin-bottom: 10px;
  }

  .empty-state p {
    color: #7d93b2;
    max-width: 500px;
    margin: 0 auto;
  }

  #modal-filtre {
    position: fixed;
    top: 0;
    height: 100vh;
    background: white;
    z-index: 1000;
    overflow-y: auto;
    transition: right 0.3s ease;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    padding: 20px;
    width: 300px;
    touch-action: pan-y;
    -webkit-overflow-scrolling: touch;
    animation-duration: 0.8s;
  }

  #modal-filtre.show-filter {
    left: 0;
  }

  .left_sidebar_area {
    height: 100%;
    padding-bottom: 60px;
  }

  @media (max-width: 768px) {
    #modal-filtre {
      width: 100%;
      user-select: none;
      -webkit-user-select: none;
      padding: 5px;
    }
  }

  #petListingDiv {
    transition: margin-left 0.3s ease;
  }

  #petListingDiv.shifted {
    margin-left: 320px;
  }

  #modal-filtre::-webkit-scrollbar {
    width: 6px;
  }

  #modal-filtre::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  #modal-filtre::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  #modal-filtre::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .hide-animation {
    display: none !important;
  }


#modal-filtre .left_sidebar_area,
#modal-filtre .left_widgets,
#modal-filtre .p_filter_widgets,
#modal-filtre .widgets_inner,
#modal-filtre .l_w_title,
#modal-filtre .list,
#modal-filtre .mb-3,
#modal-filtre .border {
  background-color: transparent !important;
}

</style>
